import React from 'react';
import useTranslations from '../useTranslations';
import SocialLinks from '../SocialLinks';

import * as S from './styled';

const Footer = () => {
  const {
    aboutProject,
    seeMorePWA,
    maintainedBy,
    contributeMessage,
  } = useTranslations();

  return (
    <S.FooterWrapper>
      <S.FooterContainer>
        <p>
          Supsim is a project for studying two-predictor suppressor effects, maintained
          by M. Nazifi and H. Fadishei from University of Bojnord
          <br/>
          Copyright © 2021 Supsim Project Team. All rights reserved. <a href="https://www.gnu.org/licenses/gpl-3.0.en.html">Terms of Use</a>
        </p>
      </S.FooterContainer>
    </S.FooterWrapper>
  );
};

export default Footer;
